import { css } from '@emotion/react';

export const buttonStyle = css`
  min-width: var(--fabric-space-gap-xl);
  width: var(--fabric-space-gap-xl);
  border: unset;
  padding: 0;
`;
